import { INTERVENTION_PRIORITIES } from '../models/interventionModel';
export const validateIntervention = (form = {}) => {
  const errors = {};
  if (!form.affairId) errors.affairId = 'L’affaire est obligatoire.';
  if (!form.name?.trim()) errors.name = 'Le nom est obligatoire.';
  if (!INTERVENTION_PRIORITIES.some((item) => item.key === form.priority)) errors.priority = 'La priorité est invalide.';
  for (const key of ['estimatedAmount', 'estimatedHours']) {
    const number = Number(String(form[key]).replace(',', '.'));
    if (form[key] !== '' && (!Number.isFinite(number) || number < 0)) errors[key] = 'La valeur doit être positive.';
  }
  return errors;
};
